export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  {
    field: 'col-opt',
    title: that.$l('INDEX.table_label_operation') || '操作',
    headerAlign: 'center',
    align: 'center',
    fixed: 'right',
    width: 100,
    slots: { default: 'opt' },
  },
  {
    title: that.$l('form_label_evgPlanOrderNo') || '计划编号',
    field: 'evgPlanOrderNo',
    minWidth: 140,
    align: 'center',
  },
  {
    title: that.$l('INDEX.form_label_status') || '状态',
    field: 'evgPlanOrderStatus',
    minWidth: 100,
    align: 'center',
    slots: { default: 'status' },
  },
  {
    title: that.$l('form_label_evgPlanOrderName') || '计划名称',
    field: 'evgPlanOrderName',
    minWidth: 220,
    align: 'left',
  },
  {
    title: that.$l('form_label_planOrderDate') || '计划日期',
    field: 'planOrderDate',
    minWidth: 100,
    align: 'center',
  },
  {
    title: that.$l('form_label_platformName') || '出货渠道',
    field: 'platformName',
    minWidth: 120,
    align: 'center',
  },
  {
    title: that.$l('form_label_custCode') || '客户',
    field: 'custName',
    minWidth: 240,
    align: 'left',
  },
  {
    title: that.$l('form_label_beginDeliveryDate') || '计划最早交期',
    field: 'beginDeliveryDate',
    minWidth: 100,
    align: 'center',
  },
  {
    title: that.$l('form_label_endDeliveryDate') || '计划最晚交期',
    field: 'endDeliveryDate',
    minWidth: 100,
    align: 'center',
  },
  {
    title: that.$l('table_label_totUnitInContainerQty') || '总产品数量',
    field: 'v_totUnitInContainerQty',
    minWidth: 120,
    align: 'center',
  },
  {
    title: that.$l('table_label_totSpecInContainerQty') || '总规格数量',
    field: 'v_totSpecInContainerQty',
    minWidth: 120,
    align: 'center',
  },
  {
    title: that.$l('INDEX.order_form_label_salesPersonCode') || '业务',
    field: 'salesPersonName',
    minWidth: 160,
    align: 'center',
  },
  {
    title: that.$l('form_label_merchandiserCode') || '跟单',
    field: 'merchandiserName',
    minWidth: 160,
    align: 'center',
  },
  {
    title: that.$l('form_label_ftyPersonCode') || '工厂跟单',
    field: 'ftyPersonName',
    minWidth: 160,
    align: 'center',
  },
  {
    title: that.$l('table_label_regionName') || '运抵国',
    field: 'regionName',
    minWidth: 120,
    align: 'center',
  },
  {
    title: that.$l('table_label_dispatchPort') || '出运港口',
    field: 'v_dispatchPort',
    minWidth: 120,
    align: 'center',
  },
  {
    title: that.$l('INDEX.table_label_created_by') || '创建人',
    field: 'createByName',
    headerAlign: 'center',
    align: 'left',
    minWidth: 170,
    slots: { default: 'createByName' }
  },
  {
    title: that.$l('INDEX.table_label_modified_by') || '修改人',
    field: 'modifyByName',
    headerAlign: 'center',
    align: 'left',
    minWidth: 170,
    slots: { default: 'modifyByName' }
  }
]
